var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 111,
    viewBox: "0 0 164 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight_07"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.999 12.3996C126.955 12.7268 133.278 15.9566 139.602 19.5832C160.342 31.4928 167.278 49.9711 153.066 68.1293C130.967 96.2882 79.4924 114.718 39.5778 106.212C30.7381 104.338 18.7705 102.686 9.99874 93.532C1.83901 85.0207 2.179 74.9025 5.91887 65.535C9.72675 55.9305 17.0705 47.0909 22.9183 41.4088C48.4855 16.6177 99.6878 -5.91406 145.994 5.96449C146.946 6.19336 147.898 5.79976 148.17 5.08542C148.442 4.37107 147.966 3.60509 147.082 3.37621C99.4155 -8.84864 46.5813 14.1669 20.2661 39.6805C12.9904 46.7658 3.47122 58.5933 0.75131 70.8306C-1.08463 79.1945 0.207062 87.7444 7.27883 95.1819C16.5945 104.933 29.3102 106.842 38.6939 108.839C79.9006 117.623 133.142 98.6552 155.922 69.5726C171.221 50.0559 163.878 30.1761 141.574 17.375C134.775 13.4401 127.839 10.0396 119.203 9.68516C118.251 9.64656 117.435 10.2234 117.435 10.9725C117.367 11.7216 118.115 12.361 118.999 12.3996Z",
    fill: "#FEA735"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.2da8088d280efcff789966f1a54f5037.svg";
export { ForwardRef as ReactComponent };